<div *ngIf="isInitialized && isPartnershipAllowed">
  <app-become-partner *ngIf="!isPartner  && !isPartnerPending"></app-become-partner>
  <app-partnership-view *ngIf="isPartner && !isPartnerPending"></app-partnership-view>
  <app-partner-pending *ngIf="isPartnerPending"></app-partner-pending>
</div>
